// extracted by mini-css-extract-plugin
export default {"base":"base-TtrmK"};